import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { LoaderService } from 'src/modules/base/services/loader.service';

@Component({
    selector: 'kx-paytm-redirect',
    templateUrl: './paytm-redirect.component.html',
    styleUrls: ['./paytm-redirect.component.scss'],
    standalone: false
})
export class PaytmRedirectComponent implements OnInit {
  success: any;
  referenceId: any;

  constructor(
    private router: ActivatedRoute,
    // private route: Router
    private loader: LoaderService
  ) { }

  ngOnInit() {
    // this.loader.showSpinner();
    this.router.queryParams.subscribe((res) => {
      if (res) {
        this.success = JSON.parse(res.success);
        this.referenceId = res.referenceId;
      }
    })
  }
  ngAfterViewInit() {
    this.createForm();
  }
  createForm() {
    const my_form: any = document.createElement('form');
    my_form.name = 'my_form';
    my_form.method = 'post';
    //my_form.action = this.redirectUrl;
    
    let my_tb: any = document.createElement('input');
    my_tb.type = 'hidden';
    my_tb.name = 'success';
    my_tb.value = this.success;
    my_form.appendChild(my_tb);
    let my_tb1: any = document.createElement('input');
    my_tb1.type = 'hidden';
    my_tb1.name = 'referenceId';
    my_tb1.value = this.referenceId;
    my_form.appendChild(my_tb1);
    document.body.appendChild(my_form);
    my_form.submit();
  };
}
